const PENDING_VERIFICATION_EMAIL_KEY = "pendingVerificationEmail";
const PENDING_VERIFICATION_USER_TYPE_KEY = "pendingVerificationUserType";

export const normalizeVerificationEmail = (email) =>
  typeof email === "string" ? email.trim() : "";

export const storePendingVerificationEmail = (email) => {
  const normalizedEmail = normalizeVerificationEmail(email);

  if (!normalizedEmail) {
    return "";
  }

  localStorage.setItem(PENDING_VERIFICATION_EMAIL_KEY, normalizedEmail);
  return normalizedEmail;
};

export const getPendingVerificationEmail = (email) => {
  const normalizedEmail = normalizeVerificationEmail(email);

  if (normalizedEmail) {
    return normalizedEmail;
  }

  return normalizeVerificationEmail(
    localStorage.getItem(PENDING_VERIFICATION_EMAIL_KEY),
  );
};

export const isAlreadyVerifiedError = (message = "") =>
  /already verified/i.test(message);

export const storePendingVerificationUserType = (userType) => {
  if (userType) {
    localStorage.setItem(PENDING_VERIFICATION_USER_TYPE_KEY, userType);
  }
};

export const getPendingVerificationUserType = () =>
  localStorage.getItem(PENDING_VERIFICATION_USER_TYPE_KEY);
